import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpService } from '../../http.service';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/components/common/messageservice';
import { DistributorProduct } from '../../models/distributor-product';
import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class DistributorProductsService extends BaseService
{
    private api: string;

	constructor(private http: HttpService, private messageService: MessageService)
	{
		super();
		this.api = environment.api_url;
	}

    public getDistributorProduct(id: number): Promise<DistributorProduct>
	{
		return this.http
			.get(this.api + 'distributor-products/' + id)
			.toPromise()
			.then(response => response.json().data as DistributorProduct)
			.catch(this.handleError);
	}

    public removeDistributorProduct(id: number): Promise<null>
    {
        return this.http
            .delete(this.api + 'distributor-products/' + id)
            .toPromise()
            .then(response => null)
            .catch(this.handleError);
    }

    public updateDistributorProduct(distributorProduct: DistributorProduct): Promise<DistributorProduct>
	{
		return this.http
			.put(this.api + 'distributor-products/' + distributorProduct.id, JSON.stringify(distributorProduct))
			.toPromise()
			.then(response => {
				return response.json().data as DistributorProduct;
			})
			.catch(this.handleError);
	}

    public saveDistributorProduct(distributorProduct: DistributorProduct): Promise<DistributorProduct>
	{
		return this.http
			.post(this.api + 'distributor-products', JSON.stringify(distributorProduct))
			.toPromise()
			.then(response => {
				return response.json().data as DistributorProduct;
			})
			.catch(this.handleError);
	}

}



// WEBPACK FOOTER //
// ./src/app/distributors/services/distributor-products.service.ts